module.exports = __webpack_public_path__ + "img/triangle.d44e395a.svg";